<div>
  <div bsModal #childModal="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header" *ngIf="header">
          <h4 id="dialog-child-name" class="modal-title pull-left">{{ header }}</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ message }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-lg" (click)="close()">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>
